import React, { useState } from 'react';
import html2canvas from 'html2canvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Printer } from 'lucide-react';
import logger from '../../../utils/logger';
import { trackProductEvent } from '@/utils/analytics/track';
const ScreenshotButtonComponent2 = ({ user, exportFilters = "" }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleScreenshot = async () => {
    setIsLoading(true);
    try {
      const canvas = await html2canvas(document.body);
      const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
      
      const link = document.createElement('a');
      link.download = 'screenshot.png';
      link.href = image;
      link.click();
      trackProductEvent(
        "report_export",
        {
          report_type: "dashboard_screenshot",
          filters: exportFilters,
          page: window.location.pathname,
          role: user?.role,
        },
        user
      );
      
    } catch (error) {
      logger.error('Failed to take screenshot:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button 
        onClick={handleScreenshot} 
        disabled={isLoading}
        className="flex lg:flex-row flex-col items-start sm:items-center lg:space-x-1 lg:space-y-0 space-y-1"
        data-analytics-id="print_dashboard"
        data-analytics-label="Print Dashboard"
      >
        <span className="text-400 text-sm text-start hidden lg:block">Print Dashboard</span>
        <Printer className="w-5 h-5 text-400 shrink-0" />
      </button>
    </div>
  );
};

export default ScreenshotButtonComponent2;